import React, { useEffect, useState } from "react";
import { TextField, Button } from "@mui/material";
// import QuotationDocs from "./QuotationDocs";
// import RelatedDocs from "./RelatedDocs";
import Box from "@mui/material/Box";
import { Switch, FormControlLabel } from "@mui/material";
import {
  FormControl,
  FormLabel,
  RadioGroup,
  Radio,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import QuotationCommentContainer from "../modals/QuotationCommentContainer";
import axios from "axios";
import { format } from "date-fns";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";

const SaleTab = ({
  selectedLead,
  customerType,
  onCustomerTypeChange,
  productsInQuotationState,
  vat,
  setVat,
  callApisAgainInQuoteLead,
  giveNextActionArrayToParent,
  setTypedAccountFromChild,
  typedAccountFromChild,
  setTypedCustomerNameFromChild,
  typedCustomerNameFromChild,
  setTypedProjectNameFromChild,
  typedProjectNameFromChild,
}) => {
  const COMPANY_CODE = localStorage.getItem("companyCode") || "-";
  const API_PATHS = localStorage.getItem("apiPaths")
    ? JSON.parse(localStorage.getItem("apiPaths"))
    : [];

  const [showDropdown, setShowDropdown] = useState(false);

  const [userDepartment, setUserDepartment] = useState(null);

  useEffect(() => {
    setUserDepartment(currentDepartmentFromLocalStorage);
  }, []);

  const currentDepartmentFromLocalStorage = localStorage.getItem(
    "currentSelectedDepartment",
  );

  const [organizationList, setOrganizationList] = useState([]);
  const [customerAccount, setCustomerAccount] = useState(""); // State to hold the TRN value

  const [currentUserAccessGroup, setCurrentUserGroupAccess] = useState(null);

  const [commentState, setCommentState] = useState("");

  const handleComment = (e) => {
    setCommentState(e.target.value);
  };

  const [openSubmitSnackbar, setOpenSubmitSnackbar] = useState(false);

  const [openSubmitSnackbarFailure, setOpenSubmitSnackbarFailure] =
    useState(false);

  const [fullHistoryOfStatusChange, setFullHistoryOfStatusChange] =
    useState(null);

  console.log(
    "productsInQuotationState in SaleTab selectedLead",
    productsInQuotationState,
    selectedLead,
  );

  const [nextActionArray, setNextActionArray] = useState(null);
  const [nextActionSelectedByUser, setNextActionSelectedByUser] =
    useState(null);

  const fetchOrganizationList = async (value) => {
    // setTimeout(async() => {
    if (!value || value.length < 1) {
      return;
    } else {
      try {
        const response = await axios.get(
          `${API_PATHS[0].API_CONFIG}/api/Search_Customer/${COMPANY_CODE}/Cust/${value}/${userDepartment}`,
        );
        // console.log("organizationList is fetched success", response.data);
        setOrganizationList(response.data);
      } catch (error) {
        console.log("Error fetching organization details:", error);
      }
    }
  };

  const handleChangeCustomerName = (event) => {
    setTypedCustomerNameFromChild(event.target.value);
    setTypedAccountFromChild("00000000");
    fetchOrganizationList(event.target.value);
  };

  const handleChangeProjectName = (event) => {
    setTypedProjectNameFromChild(event.target.value);
  };

  const handleChange = (event) => {
    // may be did this to prevent walkin to registered conversion
    // if (selectedLead?.lead_account === "00000000") {
    //   return
    // }
    const newCustomerType = event.target.value;
    console.log("newCustomerType ", newCustomerType);

    onCustomerTypeChange(newCustomerType); // This sends the updated value to the parent component

    setTypedCustomerNameFromChild("");
    setTypedAccountFromChild("00000000");
  };

  const handleNextActionSelection = (event) => {
    setNextActionSelectedByUser(event.target.value);
  };

  const handleVATChange = (event) => {
    console.log(
      "event.target.value handleVATChange SaleTab",
      event.target.value,
    );
    setVat(event.target.value);
  };

  const initialdefaultVatApplied = () => {
    setVat(vat);
  };

  useEffect(() => {
    console.log("vat SaleTab", vat);
  }, [vat]);

  useEffect(() => {
    if (nextActionArray) {
      giveNextActionArrayToParent(nextActionArray);
    }
  }, [nextActionArray]);

  useEffect(() => {
    initialdefaultVatApplied();

    // earlier like this but not needed because in any stage customer type can change
    // if (selectedLead?.lead_account === "00000000") {
    //   onCustomerTypeChange("walkin")
    // }
  }, []);

  const callApiToGetNextActionList = (receivedProductInQuotationState) => {
    console.log(
      "receivedProductInQuotationState ",
      receivedProductInQuotationState,
    );

    let compcode = COMPANY_CODE;
    let mode = "PROPOSALSTATUSOPTIONS";
    let task_owner_id = receivedProductInQuotationState
      ? receivedProductInQuotationState[0].area_code != ""
        ? receivedProductInQuotationState[0].area_code
        : "Draft"
      : "-";
    let task_id = "-";

    const apiUrl = `${API_PATHS[0].API_CONFIG}/api/CRMTaskHistoryList/${compcode}/${mode}/${task_owner_id}/${task_id}`;
    axios
      .get(apiUrl)
      .then((res) => {
        setNextActionArray(res.data);
      })
      .catch((err) => {});
  };

  const callApiToGetFullHistoryOfStatusChange = (
    receivedProductInQuotationState,
  ) => {
    console.log(
      "callApiToGetFullHistoryOfStatusChange SaleTab ",
      receivedProductInQuotationState,
      selectedLead,
    );

    const currentUserfromLocalStorage = JSON.parse(
      localStorage.getItem("currentUser"),
    );

    let currentUserEMPID = "-";

    if (currentUserfromLocalStorage) {
      console.log(
        "currentUserfromLocalStorage[0] ",
        currentUserfromLocalStorage[0],
      );
      currentUserEMPID = currentUserfromLocalStorage[0]?.EMPID;
    } else {
      console.log(
        "currentUserfromLocalStorage[0] else",
        currentUserfromLocalStorage[0],
      );
    }

    const currentUserObject = JSON.parse(localStorage.getItem("currentUser"));
    const userAccessGroupNow = currentUserObject[0].accessgrp;

    let compcode = COMPANY_CODE;
    let mode = "PROPOSALTIMELINE";
    let task_owner_id = selectedLead.deptno;
    let task_id = productsInQuotationState
      ? productsInQuotationState[0]?.quotation_number + ""
      : "NEW";

    const apiUrl = `${API_PATHS[0].API_CONFIG}/api/CRMTaskHistoryList/${compcode}/${mode}/${task_owner_id}/${task_id}`;

    console.log("apiurl >> status change", apiUrl);
    axios
      .get(apiUrl)
      .then((res) => {
        setFullHistoryOfStatusChange(res.data);
      })
      .catch((err) => {});
  };

  const callAPIToChangeStatus = (comment) => {
    console.log(
      "productsInQuotationState >> selectedLead>> callAPIToChangeStatus",
      productsInQuotationState,
      selectedLead,
    );

    const currentUserfromLocalStorage = JSON.parse(
      localStorage.getItem("currentUser"),
    );

    let currentUserEMPID = "-";

    if (currentUserfromLocalStorage) {
      console.log(
        "currentUserfromLocalStorage[0] ",
        currentUserfromLocalStorage[0],
      );
      currentUserEMPID = currentUserfromLocalStorage[0]?.EMPID;
    } else {
      console.log(
        "currentUserfromLocalStorage[0] else",
        currentUserfromLocalStorage[0],
      );
    }

    const currentUserObject = JSON.parse(localStorage.getItem("currentUser"));
    const userAccessGroupNow = currentUserObject[0].accessgrp;

    console.log(
      "userAccessGroupNow  selectedLead.deptno >>",
      userAccessGroupNow,
      selectedLead.deptno,
    );

    const jsonObject = [
      {
        CmpCode: COMPANY_CODE,
        mode: "PROPOSAL",
        DocNo: productsInQuotationState
          ? productsInQuotationState[0]?.quotation_number + ""
          : "NEW",
        deptno: selectedLead.deptno,
        Status: nextActionSelectedByUser,
        Comments: comment,
        UserID: currentUserEMPID?.trim(),
        created_on: format(new Date(), "yyyy-MM-dd"),
      },
    ];

    const jsonToSend = JSON.stringify(jsonObject);

    const apiUrl = `${API_PATHS[0].API_CONFIG}/api/ProposalStatus`;

    axios
      .post(apiUrl, jsonToSend, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        if (res.data.result === "Saved") {
          setOpenSubmitSnackbar(true);

          setCommentState("");

          callApisAgainInQuoteLead(selectedLead.Prop_No);
        } else {
          setOpenSubmitSnackbarFailure(true);
        }
      })
      .catch((err) => {});
  };

  const handleCloseSubmitSnackbar = () => {
    setOpenSubmitSnackbar(false);
    setOpenSubmitSnackbarFailure(false);
  };

  useEffect(() => {
    if (productsInQuotationState) {
      if (productsInQuotationState[0]) {
        callApiToGetNextActionList(productsInQuotationState);
        callApiToGetFullHistoryOfStatusChange(productsInQuotationState);
      }

      console.log(
        "customer type after productsInQuotationState ",
        productsInQuotationState[0],
        typeof productsInQuotationState[0].customer_account_from_details,
      );
      // set customer type
      if (
        productsInQuotationState[0].customer_account_from_details === "00000000"
      ) {
        onCustomerTypeChange("walkin");
      } else {
        onCustomerTypeChange("registered");
      }

      setTypedCustomerNameFromChild(
        productsInQuotationState[0].customer_name_from_details,
      );
      setTypedAccountFromChild(
        productsInQuotationState[0].customer_account_from_details,
      );
      setTypedProjectNameFromChild(
        productsInQuotationState[0].project_name_from_details,
      );
    }
  }, [productsInQuotationState]);

  useEffect(() => {
    const currentUserObject = JSON.parse(localStorage.getItem("currentUser"));
    const userAccessGroup = currentUserObject[0].accessgrp;
    setCurrentUserGroupAccess(userAccessGroup);
  }, []);

  const selectCustomerOrganization = (customer) => {
    setTypedAccountFromChild(customer.account?.trim());
    setTypedCustomerNameFromChild(customer.Custname?.trim());
  };

  return (
    <div style={{ display: "flex", alignItems: "flex-end" }}>
      <div
        className="flex flex-col justify-between items-left gap-4"
        style={{ width: "60%" }}
      >
        <div className="flex gap-4" style={{ width: "100%" }}>
          <p style={{ display: "flex", flexDirection: "column" }}>
            <span style={{ color: "#a7a7a7" }}>Lead ID</span>
            <span>{selectedLead?.lead_id}</span>
          </p>
          <p style={{ display: "flex", flexDirection: "column" }}>
            {" "}
            <span style={{ color: "#a7a7a7" }}>Stage </span>
            <span>
              {productsInQuotationState
                ? productsInQuotationState[0]?.area_code != ""
                  ? productsInQuotationState[0]?.area_code
                  : "Draft"
                : "DRAFT--"}
            </span>
          </p>

          <div>
            {
              <FormControl sx={{ minWidth: "140px" }} variant="standard">
                <InputLabel>Next Action</InputLabel>
                <Select
                  value={nextActionSelectedByUser}
                  onChange={handleNextActionSelection}
                >
                  {nextActionArray?.map((item) => {
                    return (
                      <MenuItem value={item.new_status}>
                        {item.new_status}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            }
          </div>

          <p style={{ display: "flex", flexDirection: "column" }}>
            {" "}
            <span style={{ color: "#a7a7a7" }}>QO No </span>
            <span>
              {productsInQuotationState
                ? productsInQuotationState[0]?.quotation_number
                : "NEW"}
            </span>
          </p>

          <p style={{ display: "flex", flexDirection: "column" }}>
            {" "}
            <span style={{ color: "#a7a7a7" }}>Rev No </span>
            <span>
              {productsInQuotationState
                ? productsInQuotationState[0]?.revision_number
                : "0"}
            </span>
          </p>
        </div>

        <div className="flex justify-left items-center gap-8 ">
          <div>
            <FormControl component="fieldset">
              <FormLabel component="legend">Customer Type</FormLabel>
              <RadioGroup row value={customerType} onChange={handleChange}>
                <FormControlLabel
                  value="registered"
                  control={<Radio />}
                  label="Registered Customer"
                />
                <FormControlLabel
                  value="walkin"
                  control={<Radio />}
                  label="Walk-in"
                />
              </RadioGroup>
            </FormControl>
          </div>

          <div className="w-40 ">
            <FormControl fullWidth variant="standard">
              <InputLabel>VAT Category</InputLabel>
              <Select value={vat} onChange={handleVATChange}>
                {/* <MenuItem value=''>Select VAT Options</MenuItem> */}
                <MenuItem value="noVat">0% (No VAT)</MenuItem>
                <MenuItem value="vatApplied">VAT Applied</MenuItem>
                <MenuItem value="vatExempted">VAT Exempted</MenuItem>
                <MenuItem value="outOfScope">Out of Scope</MenuItem>
              </Select>
            </FormControl>
          </div>
        </div>

        <div className="flex gap-4">
          <div>
            <div className="flex">
              {console.log(
                "typedCustomerNameFromChild >>>",
                typedCustomerNameFromChild,
              )}
              <div className="mb-0 relative">
                <TextField
                  sx={{ minWidth: "350px" }}
                  label="Customer/Organization"
                  // value={selectedLead?.lead ? selectedLead.lead : "New Customer"}
                  // value={selectedLead?.lead_primarycontact}
                  value={
                    typedCustomerNameFromChild ? typedCustomerNameFromChild : ""
                  }
                  size="small"
                  variant="standard"
                  onChange={(e) => {
                    handleChangeCustomerName(e);
                    setShowDropdown(true);
                  }}
                  autoComplete="off"
                />
                {organizationList &&
                  showDropdown &&
                  typedCustomerNameFromChild?.length > 0 && (
                    <div className="absolute top-15 left-0 w-64 bg-gray-100 max-h-[300px] overflow-y-auto scrollbar-thin shadow-lg z-50 border border-gray-300">
                      {console.log("organizationList:", organizationList)}
                      {organizationList
                        // ?.filter((product) => product.Code) // Filter matching products
                        .map((organization, index) => (
                          <div
                            onClick={() => {
                              selectCustomerOrganization(organization);
                              setShowDropdown(false);
                            }}
                            key={index}
                            className="px-1 py-0.5 border bg-white hover:bg-gray-200"
                          >
                            <p className="font-normal">
                              {organization.Custname}
                            </p>
                            {/* <p className="text-xs text-gray-500">
                                {product.Description}
                              </p>
                              <p className="text-xs text-gray-500">
                                {product.Imagepath}
                              </p> */}
                          </div>
                        ))}
                    </div>
                  )}
              </div>
              <div>
                <p className="font-light text-[#00000099] text-xs">
                  Customer Account
                </p>
                <span>{typedAccountFromChild}</span>
              </div>
            </div>

            <p className="mt-2">
              <TextField
                sx={{ minWidth: "350px" }}
                label="Project"
                value={typedProjectNameFromChild}
                size="small"
                variant="standard"
                onChange={(e) => {
                  handleChangeProjectName(e);
                }}
                autoComplete="off"
              />
            </p>
          </div>
        </div>
      </div>

      <div style={{ width: "40%" }}>
        {productsInQuotationState &&
          productsInQuotationState[0]?.quotation_number != "" && (
            <QuotationCommentContainer
              callAPIToChangeStatus={callAPIToChangeStatus}
              fullHistoryOfStatusChange={fullHistoryOfStatusChange}
              productsInQuotationState={productsInQuotationState}
              nextActionSelectedByUser={nextActionSelectedByUser}
              handleComment={handleComment}
              commentState={commentState}
              setCommentState={setCommentState}
              setNextActionSelectedByUser={setNextActionSelectedByUser}
            />
          )}
      </div>

      {/* <div className="flex flex-col gap-4 justify-center items-center">
        <TextField
          label="Quotation Date"
          value={selectedQuotationDate}
          size="small"  
          variant="standard"
          InputProps={{
            readOnly: true,
          }}
        />
        <TextField
          label="Promised Date"
          value={selectedPromisedDate}
          size="small"
          variant="standard"
          type="datetime-local"
          onChange={handlePromisedDateChange}
          InputLabelProps={{ shrink: true }}
        />
        <TextField
          label="Followup Date"
          value={selectedFollowupDate}
          size="small"
          variant="standard"
          type="datetime-local"
          onChange={handleFollowupDateChange}
          InputLabelProps={{ shrink: true }}
        /> 
      </div> */}

      <Snackbar
        open={openSubmitSnackbar}
        autoHideDuration={3000}
        onClose={handleCloseSubmitSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <MuiAlert severity="success" sx={{ width: "100%" }}>
          Successfully Saved!
        </MuiAlert>
      </Snackbar>

      <Snackbar
        open={openSubmitSnackbarFailure}
        autoHideDuration={3000}
        onClose={handleCloseSubmitSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <MuiAlert severity="success" sx={{ width: "100%" }}>
          Something went wrong, Please try later
        </MuiAlert>
      </Snackbar>
    </div>
  );
};

export default SaleTab;
